export var PRIVACY_ATTR_NAME = 'data-dd-privacy';
export var PRIVACY_ATTR_VALUE_HIDDEN = 'hidden';
export var PRIVACY_ATTR_VALUE_INPUT_IGNORED = 'input-ignored';
export var PRIVACY_ATTR_VALUE_INPUT_MASKED = 'input-masked';
export var PRIVACY_CLASS_HIDDEN = 'dd-privacy-hidden';
export var PRIVACY_CLASS_INPUT_IGNORED = 'dd-privacy-input-ignored';
export var PRIVACY_CLASS_INPUT_MASKED = 'dd-privacy-input-masked';
//# sourceMappingURL=constants.js.map